import { Palette } from "@mui/material";
import { borderGeneralStyle } from "@utils/cssStyles";

export const fileBlockStackSx = (palette: Palette) => ({
  ...borderGeneralStyle,
  borderRadius: 1.5,
  backgroundColor: palette.background.paper,
  p: 2,
  mb: 1,
});

export const fileNameSx = (palette: Palette) => ({
  minWidth: 0,
  flex: 1,
  fontWeight: 600,
  color: palette.text.heading,
});
